import { initStore } from '../src/store';
import withRematch from '../src/utils/withRematch';
import Layout from '../src/containers/MineLayout';
import App from '../src/containers/App';

const AppPage = (props) => {
    return (
        <Layout {...props}>
            <App/>
        </Layout>
    );
};

AppPage.getInitialProps = async function(ctx) {
    const { pathname, req, store } = ctx;

    let token = req ? req.cookies.token : null;

    await store.dispatch.user.getUserInfoFull({token});

    let curLang = req && req.language ? req.language.split('-')[0] : 'ru';

    return {
        headerClass: '',
        curLang,
        pathname,
        title: 'MOVER: Приложения',
        description: '«MOVER-Грузовое такси» — Комплекс сервисов и приложений, которые помогут вам в 3 клика заказать грузовой автомобиль под любые нужды. «MOVER-Водитель» — Незаменимый помощник любого перевозчика, бортовой компьютер, который поможет стать настоящим мастером своего дела. «MOVER-Для Бизнеса» — Мы в считанные дни автоматизируем ваши логистические процессы, поможем вам зарабатывать на них и получать всю информацию в режиме одного окна.'
    }
};

const mapState = state => ({
    lang: state.lang,
    userInfo: state.user,
    activeOrder: state.orders.activeOrder
});

const mapDispatch = ({ orders: { acceptedOrder, declinedOrder }, user: { getUserInfoFull }, calculator: { searchStop, searchStart, update }, ws: { connect }}) => ({
    getUserInfoFull     :    () => getUserInfoFull(),
    calculatorUpdate:   (data) => update(data),
    wsConnect:          () => { connect() },
    searchStop:         (data) => searchStop(data),
    searchStart:        (data) => searchStart(data),
    acceptedOrder:      (orderId) => acceptedOrder(orderId),
    declinedOrder:      (orderId) => declinedOrder(orderId),
});

export default withRematch(initStore, mapState, mapDispatch)(AppPage);
